import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AdminDashboard from '../pages/dashboards/AdminDashboard';
import AdvisorDashboard from '../pages/dashboards/AdvisorDashboard';
import LawFirmDashboard from '../pages/dashboards/LawFirmDashboard';
import ClientDashboard from '../pages/dashboards/ClientDashboard';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const RoleBasedRouter = () => {
  const { profile, loading, missingProfile } = useAuth();

  if (loading || !profile) {
    return (
      <div className="flex flex-col justify-center items-center h-64">
        <SafeIcon icon={FiIcons.FiLoader} className="animate-spin h-8 w-8 text-slate-400 mb-2" />
        <p className="text-sm text-slate-500">Checking permissions...</p>
      </div>
    );
  }

  if (missingProfile) {
    return <Navigate to="/missing-profile" />;
  }

  // Routing logic strictly based on public.profiles.role
  switch (profile.role) {
    case 'platform_admin':
      return <AdminDashboard />;
    
    case 'advisor_admin':
    case 'advisor_user':
      return <AdvisorDashboard />;
    
    case 'attorney':
    case 'legal_staff':
      return <LawFirmDashboard />;
    
    case 'client':
      return <ClientDashboard />;
    
    default:
      console.warn('Unknown profile role:', profile.role);
      return (
        <div className="text-center py-12 bg-white rounded-lg border border-slate-200">
          <SafeIcon icon={FiIcons.FiAlertTriangle} className="mx-auto h-12 w-12 text-amber-500 mb-4" />
          <h2 className="text-2xl font-semibold text-slate-800">Unauthorized</h2>
          <p className="text-slate-600 mt-2">Your role "{profile.role}" is not recognized by the dashboard router.</p>
        </div>
      );
  }
};

export default RoleBasedRouter;